// @ts-nocheck
import appStore from '../../app-config.json';

// 読み込み専用
export const AppConfig = {
  get: (key: string): any => {
    return appStore[key];
  },
  // set: (key: string, value: any) => {
  //   appStore.set(key, value);
  // }
};
